import { Label } from '@components/label/label';
import classNames from 'classnames';

import { LabelSecondaryProps } from './label.type';

export const LabelSecondary = ({ children, hasError = false, className, ...props }: LabelSecondaryProps) => {
  return (
    <Label
      {...props}
      className={classNames(
        {
          'text-critical': hasError,
          'text-primary': !hasError,
        },
        'text-body-s',
        className
      )}>
      {children}
    </Label>
  );
};
